// removed by extract-text-webpack-plugin
module.exports = {"uploadFallback":"onfido-sdk-ui-CameraError-uploadFallback","errorContainer":"onfido-sdk-ui-CameraError-errorContainer","errorContainerType":"onfido-sdk-ui-CameraError-errorContainerType","errorHasBackdrop":"onfido-sdk-ui-CameraError-errorHasBackdrop","errorMessage":"onfido-sdk-ui-CameraError-errorMessage","fallbackLink":"onfido-sdk-ui-CameraError-fallbackLink"};


//////////////////
// WEBPACK FOOTER
// ./components/CameraError/style.css
// module id = 368
// module chunks = 1